import React, { useState } from 'react'
import HorizontalLine from '@components/HorizontalLine'
import Show from '@components/Show'
import { ExpandMoreIcon, ExpandLessIcon } from '@components/Icons'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { colors } from '@lib/colors'

interface WorkOrderDescriptionProps {
  description?: string
}

const WorkOrderDescription = ({ description }: WorkOrderDescriptionProps) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const style = expanded ? styles.descriptionExpanded : styles.descriptionCollapsed
  const toggleExpanded = () => setExpanded(!expanded)

  return (
    <View style={ style }>

      <Show
        when={description}
        fallback={
          <Text style={ styles.noDescriptionText }>No description provided</Text>
        }
      >
        <Text style={ styles.descriptionText }>{ description }</Text>
      </Show>

      <Pressable style={ styles.expandButton } onPress={ toggleExpanded }>
        <Show
          when={ expanded }
          fallback={ <ExpandMoreIcon color={ colors.gray[600] } /> }
        >
          <ExpandLessIcon color={ colors.gray[600] } />
        </Show>
        <HorizontalLine color={colors.gray[400]} />
      </Pressable>

    </View>
  )
}

export default WorkOrderDescription

const styles = StyleSheet.create({
  descriptionText: {
    color: colors.gray[700],
  },
  noDescriptionText: {
    color: colors.gray[600],
    textAlign: 'center',
  },
  descriptionCollapsed: {
    height: 40,
    marginBottom: 50,
  },
  descriptionExpanded: {
    height: 'auto',
    marginBottom: 20,
  },
  expandButton: {
    alignItems: 'center',
    alignSelf: 'stretch',
    paddingTop: 5,
  },
})
